import React from 'react';
import { motion } from 'framer-motion'; // Import motion from framer-motion
import college from "../../assets/Home/college.jpg";
import SidebarGalleryPage from "../../Components/Main/Sidebargallery"

const Vision = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="flex flex-wrap lg:flex-nowrap p-10 gap-8">
        <div className="">
          <div>
            {/* Animated College Image */}
            <motion.img
              src={college}
              alt="CSE"
              className="w-full shadow-md p-2 border-4 border-teal-500 rounded-lg"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            />
          </div>
          <div>
            {/* Vision Section with Animation */}
            <motion.div
              className="mt-10 rounded-lg shadow-md"
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="border-4 border-teal-500 rounded-lg p-2">
                  <h2 className="text-white bg-teal-500 p-2 font-bold rounded-sm text-xl">Vision</h2>
                <div className=" mt-4 p-2 text-gray-800">
                  <p className="mb-4">
                    Government Women’s Polytechnic College, Sehore is offering innovative and skill-based Job-Oriented
                    Diploma Programs. It also serves many job-oriented programs like Women Industrial Training, Skill
                    development programs for unemployed OBC & SC/ST category. This organization provides quality learning
                    for each and every student by trained faculty and staff.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
           {/* Right Section: Gallery */}
           <div className="w-full">
                <SidebarGalleryPage />
          </div>
      </div>
    </div>
  );
};

export default Vision;
